module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "keep-alive": "",
      "thisuser": this.$parent.user,
      "personality": this.$parent.profile.personality,
      "favourites": this.$parent.profile.favourites
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "mobile-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-matches",
    attrs: {
      "to": "/matches"
    }
  }, [_vm._v("Matches")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-everyone",
    attrs: {
      "to": "/everyone"
    }
  }, [_vm._v("Everyone")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-chats notify",
    attrs: {
      "to": "/chats"
    }
  }, [_vm._v("Chats")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-favourites",
    attrs: {
      "to": "/favourites"
    }
  }, [_vm._v("Favourites")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295fa018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 697
// module chunks = 1